// Kauftunnel: Warenkorb (Cart.jsx) und Checkout (Checkout.jsx).
// Übersetzung von fr/tunnel.js — gleiche Schlüssel, gleiche Reihenfolge.
// Ton: « du » im Warenkorb, « Sie » ab dem Checkout (wie im Französischen und
// im Niederländischen). Die Meldungen über entfernte Artikel siezen bereits im
// Französischen — das ist hier übernommen.
export default {
  // --- Warenkorb (Cart.jsx) ---
  'tunnel.panier.seoTitre': 'Mein Warenkorb',
  'tunnel.panier.seoDescription':
    'Sehen Sie sich Ihren Joyful-Reveal-Warenkorb an und bezahlen Sie sicher mit Stripe. Sie haben einen Gutscheincode? Geben Sie ihn hier erneut ein.',
  'tunnel.panier.titre': '🛒 Dein Warenkorb',
  'tunnel.panier.sousTitreVide':
    'Beginne dein Abenteuer und sammle die Puzzleteile',
  'tunnel.panier.sousTitreUn': 'Du hast {n} Teil in deinem Warenkorb',
  'tunnel.panier.sousTitrePlusieurs': 'Du hast {n} Teile in deinem Warenkorb',
  'tunnel.panier.retireTitreUn': 'Ein Artikel wurde aus Ihrem Warenkorb entfernt',
  'tunnel.panier.retireTitrePlusieurs':
    'Es wurden Artikel aus Ihrem Warenkorb entfernt',
  'tunnel.panier.retireDetail':
    '{noms} — dieses Pack wird nicht mehr angeboten. Unsere aktuellen Packs finden Sie im',
  'tunnel.panier.retireDetailLien': 'Shop',
  'tunnel.panier.progression': 'Sammlung im Aufbau',
  'tunnel.panier.videTitre': 'Leerer Warenkorb',
  'tunnel.panier.videTexte':
    'Hier ist noch nichts zu sehen... noch nicht! Beginne dein Abenteuer und sammle die Puzzleteile.',
  'tunnel.panier.videCta': '🎯 Zurück zum Abenteuer',
  'tunnel.panier.langue': 'Sprache:',
  'tunnel.panier.retirerDuPanier': 'Aus dem Warenkorb entfernen',
  'tunnel.panier.sousTotal': 'Zwischensumme',
  'tunnel.panier.reduction': 'Rabatt ({code})',
  'tunnel.panier.retirer': 'Entfernen',
  'tunnel.panier.livraison': 'Versand',
  'tunnel.panier.livraisonADeterminer': 'Wird noch berechnet',
  'tunnel.panier.codePromo': 'Gutscheincode',
  'tunnel.panier.appliquer': 'Anwenden',
  'tunnel.panier.promoAppliquee': 'Code "{code}" angewendet!',
  'tunnel.panier.total': 'Gesamt',
  'tunnel.panier.offreSpeciale':
    'Besondere Sammlung freigeschaltet! Du bist dem großen Geheimnis ganz nah.',
  'tunnel.panier.continuerCollecter': '← Weiter sammeln',
  'tunnel.panier.procederPaiement': '🎯 Zur Kasse',

  // --- Checkout (Checkout.jsx) ---
  'tunnel.checkout.seoTitre': 'Bezahlung - Sicherer Checkout',
  'tunnel.checkout.seoDescription':
    'Schließen Sie Ihren Kauf des Joyful-Reveal-Puzzles sicher mit Stripe ab. Schnelle Lieferung nach Deutschland und in ganz Europa.',
  'tunnel.checkout.chargement': 'Wird geladen...',
  'tunnel.checkout.erreur': '❌ Fehler: {message}',
  'tunnel.checkout.etape': 'Schritt {n} / 3',
  'tunnel.checkout.sansCompte':
    '✅ Sie müssen kein Konto anlegen — Ihre E-Mail-Adresse genügt für die Bestätigung und die Sendungsverfolgung.',
  // Drei Teile, im JSX durch einen Link getrennt und je mit einem Leerzeichen
  // verbunden: « Sie haben schon ein Konto? [Melden Sie sich an] und finden … »
  // Darum ohne Komma formuliert — vor dem Schlussteil steht immer ein Leerzeichen.
  'tunnel.checkout.dejaCompte': 'Sie haben schon ein Konto?',
  'tunnel.checkout.dejaCompteLien': 'Melden Sie sich an',
  'tunnel.checkout.dejaCompteFin': 'und finden Sie Ihre Bestellungen wieder.',
  'tunnel.checkout.etape1Titre': '📍 Lieferadresse',
  'tunnel.checkout.champNomComplet': 'Vollständiger Name',
  'tunnel.checkout.champEmail': 'E-Mail',
  'tunnel.checkout.champAdresse': 'Adresse',
  'tunnel.checkout.champVille': 'Ort',
  'tunnel.checkout.champCodePostal': 'Postleitzahl',
  'tunnel.checkout.choisirPays': 'Land auswählen',
  'tunnel.checkout.paysFR': 'Frankreich',
  'tunnel.checkout.paysBE': 'Belgien',
  'tunnel.checkout.paysLU': 'Luxemburg',
  'tunnel.checkout.paysDE': 'Deutschland',
  'tunnel.checkout.paysES': 'Spanien',
  'tunnel.checkout.paysIT': 'Italien',
  'tunnel.checkout.paysNL': 'Niederlande',
  'tunnel.checkout.paysPT': 'Portugal',
  'tunnel.checkout.etape2Titre': '🚚 Versandart',
  'tunnel.checkout.calculTarifs': 'Tarife werden berechnet...',
  'tunnel.checkout.etapeSuivanteRequise': 'Nächster Schritt erforderlich',
  'tunnel.checkout.choisirPointRelaisTexte':
    'Wählen Sie den Abholpunkt, an dem Sie Ihre Bestellung abholen möchten',
  'tunnel.checkout.choisirPointRelaisBouton':
    '🗺️ HIER KLICKEN, UM IHREN ABHOLPUNKT ZU WÄHLEN',
  'tunnel.checkout.pointRelaisSelectionne': '✓ Abholpunkt ausgewählt',
  'tunnel.checkout.modifier': 'Ändern',
  // Die Abholpunkt-Auswahl ist ein externes Skript: sie kann ausfallen (Netz,
  // Werbeblocker). Diese Meldungen ersetzen englische alert()-Fenster.
  'tunnel.checkout.selecteurIndisponible':
    'Die Karte mit den Abholpunkten konnte nicht geladen werden. Laden Sie die Seite neu, und schalten Sie bei anhaltenden Problemen Ihren Werbeblocker für die Bestellung kurz aus.',
  'tunnel.checkout.choisirTransporteurDabord':
    'Wählen Sie zuerst oben eine Versandart.',
  'tunnel.checkout.selecteurErreur':
    'Die Karte mit den Abholpunkten hat nicht geantwortet. Versuchen Sie es gleich noch einmal.',
  // Versandart bei jeder Option: Sendcloud liefert rund ein Dutzend zurück, und
  // der Produktname sagt nicht, wo das Paket ankommt.
  'tunnel.checkout.modePointRelais': '📍 Abholpunkt',
  'tunnel.checkout.modeDomicile': '🏠 Nach Hause',
  // Erscheint nur, wenn die Beteiligung tatsächlich besteht (siehe fr/tunnel.js).
  'tunnel.checkout.participation': '💚 Wir übernehmen {montant} € der Versandkosten für diese Strecke',
  // Stimmt, weil der Preis auf den Cent genau vom Versanddienstleister kommt.
  'tunnel.checkout.portSansMarge':
    'Der angezeigte Preis ist der des Versanddienstleisters, auf den Cent genau — wir schlagen nichts darauf.',
  'tunnel.checkout.livraisonDomicileTexte':
    '✓ Direkt an Ihre Adresse geliefert: {adresse}',
  'tunnel.checkout.indispoTitre':
    '⏳ Lieferung in dieses Land vorübergehend nicht möglich',
  'tunnel.checkout.indispoTexte':
    'Zurzeit bietet uns kein Versanddienstleister diese Strecke an. Wir arbeiten daran, sie zu öffnen — prüfen Sie in der Zwischenzeit die eingegebene Adresse (Postleitzahl und Ort), wählen Sie ein anderes Lieferland, oder schreiben Sie uns: Gemeinsam finden wir eine Lösung.',
  'tunnel.checkout.indispoModifierAdresse': '← Adresse ändern',
  'tunnel.checkout.indispoContact': '💬 Kontakt aufnehmen',
  'tunnel.checkout.voirPlusOptions': '↓ Die {n} weiteren Versanddienstleister anzeigen',
  'tunnel.checkout.voirMoinsOptions': '↑ Weniger Optionen anzeigen',
  'progression.complete': '✨ ENTHÜLLUNG KOMPLETT! ✨',
  'progression.restant': 'Noch {n} Teile zu entdecken',
  // Le tunnel de commande compte des ÉTAPES : y afficher « Plus que 23
  // pièces à découvrir » juste au-dessus du bouton de paiement inquiétait
  // l'acheteur au lieu de le rassurer.
  'progression.etapeRestante': "Noch {n} Schritt bis zur Zahlung",
  'progression.etapesRestantes': "Noch {n} Schritte bis zur Zahlung",
  'progression.pretAPayer': "Letzter Schritt: die Zahlung",
  'tunnel.panier.etape': "Ihr Warenkorb",
  'tunnel.checkout.tarifsAttenteLongue':
    'Einen Moment bitte, die Verbindung zum Versanddienstleister dauert etwas länger als sonst.',
  'tunnel.checkout.tarifsReprise':
    'Der Versanddienstleister antwortet nicht, wir versuchen es erneut ({n}/{total})…',
  'tunnel.checkout.tarifsErreurTitre':
    '⚠️ Die Versandkosten konnten nicht berechnet werden',
  'tunnel.checkout.tarifsErreurTexte':
    'Wir haben es dreimal vergeblich versucht. Das liegt nicht an Ihrem Land, sondern an unserer Verbindung zum Versanddienstleister. Starten Sie die Berechnung neu — bleibt es dabei, schreiben Sie uns, und wir schließen die Bestellung gemeinsam mit Ihnen ab.',
  'tunnel.checkout.tarifsReessayer': '↻ Erneut versuchen',
  'tunnel.checkout.etape3Titre': '💳 Bezahlung',
  'tunnel.checkout.redirectionStripe':
    'Sie werden zu einer sicheren Zahlungsseite von Stripe weitergeleitet.',
  'tunnel.checkout.redirection': 'Weiterleitung...',
  'tunnel.checkout.procederPaiement': 'Sicher bezahlen →',
  'tunnel.checkout.retour': '← Zurück',
  'tunnel.checkout.continuer': 'Weiter →',
  'tunnel.checkout.recapitulatif': '📦 Übersicht',
  'tunnel.checkout.recapLivraison': '🚚 Versand ({nom})',
  'tunnel.checkout.recapReduction': '🏷️ Rabatt ({code})',
  'tunnel.checkout.total': 'Gesamt:',
  'tunnel.checkout.paiementReussi': 'Zahlung erfolgreich!',
};
